/* 
Allows the connected wallet to set an allowance
(How much LPT has the BondingManager been authorized to use)
*/
import { useLivepeerToken } from "../../../hooks/WithSmartContracts";
import SmartContractAction from "../components/SmartContractAction";
import { useState } from "react";
import { ethers } from "ethers";

export default function ApproveLPT(props) {
  const [isPending, setIsPending] = useState(false);
  const [thisTxn, setTxn] = useState("");
  const [thisErrMsg, setErrMsg] = useState("");
  const [isFinished, setIsFinished] = useState(false);
  const livepeerToken = useLivepeerToken();

  const approveLPT = async () => {
    try {
      const { ethereum } = window;
      if (ethereum) {
        setIsPending(true);
        const txn = await livepeerToken.approve(
          "0x35Bcf3c30594191d53231E4FF333E8A770453e40",
          ethers.constants.MaxUint256
        );
        setTxn(txn.hash);
        await txn.wait();
        setIsFinished(true);
        props.refreshWallet();
      }
    } catch (error) {
      if (error.reason) {
        setErrMsg(error.reason);
      }
      props.setErr(true);
      setIsPending(false);
      setTxn(false);
      setIsFinished(false);
    }
  };

  return (
    <SmartContractAction
      isPending={isPending}
      txn={thisTxn}
      thisErrMsg={thisErrMsg}
      isFinished={isFinished}
      action={approveLPT}
      actionMessage={"Approve LPT"}
      finishedMessage={"Moving onto next step..."}
      pendingMessage={"Approving LPT..."}
    />
  );
}
